<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeItem(itemToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm12 md6 lg3 pa-4 mt-3>
                <v-hover>
                    <v-card slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-flex xs12>
                            <v-flex xs12 pt-4 pb-3 pr-2 pl-4>
                                <span class="title">Brand Shopify Settings</span>
                            </v-flex>
                            <v-divider/>
                            <v-progress-linear class="branch-office-loading" :active="loading"
                                               :indeterminate="true"/>
                        </v-flex>
                        <v-list class="branchOfficesList" two-line subheader>
                            <template v-for="(item, index) in items">
                                <v-list-tile ripple avatar
                                             @click="editItem(index)">
                                    <v-list-tile-avatar>
                                        <v-icon>business_center</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{item.name}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>{{item.base_url}} - {{item.api_version}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon ripple @click="showDeleteDialog(index)">
                                            <v-icon color="red lighten-1">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider/>
                            </template>
                        </v-list>
                        <v-flex v-if="items == null || items.length <= 0">
                            <v-card-text><p class="text-xs-center grey--text">No Brand Shopify Settings yet</p>
                            </v-card-text>
                        </v-flex>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn mt-5 dark color="secondary" @click="addNewItem">Add
                                <v-icon class="white--text" right>add</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-hover>
            </v-flex>

            <v-flex xs12 md12 lg9 pa-4 mt-3>

                <v-hover>
                    <v-card v-show="!formDisabled"
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-form ref="form" v-model="formValidation" lazy-validation>
                        <v-layout wrap>
                                <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">General</span>
                                        <v-divider/>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedItem.name"
                                                      label="Name">
                                        </v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-flex xs12 pt-3 pb-2>
                                            <span class="title">API Endpoint Config</span>
                                            <v-divider/>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field :disabled="formDisabled"
                                                          v-model="selectedItem.base_url"
                                                          label="Base URL with NO Auth">
                                            </v-text-field>
                                        </v-flex>
                                      <v-flex xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedItem.access_token"
                                                      label="AccessToken For AUTH">
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedItem.api_version"
                                                      label="API Version">
                                        </v-text-field>
                                      </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-flex xs12 pt-3 pb-2>
                                            <span class="title">Additional</span>
                                            <v-divider/>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                        </v-layout>
                        </v-form>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                                   @click.native="saveAndGoToNextTab(3)">Save
                                <v-icon class="white--text" right>save</v-icon>
                            </v-btn>
                        </v-card-actions>

                    </v-card>
                </v-hover>

            </v-flex>
        </v-layout>

    </div>
</template>


<script>
    import {
        BrandConfigurationShopifySettings,
        BrandConfiguration,
        Settings
    } from '../../../store/namespace-helper'

    export default {
      components: {},
      name: 'brand-configuration-shopify-settings',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          removeDialog: false,
          itemToDelete: null,
          onDismissed: false,
          formUpdated: 0,
          formDisabled: true,
          uploadedDocument: null,
          showPW: false,
          confirmPW: null,
          formValidation: false,
          passwordConfirmationRules: [
            (v) => (v === this.selectedItem.smtp_password || this.confirmPW === undefined) || 'Passwords must match'
          ]
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadItems()
            } else {
              this.formDisabled = true
              this.formUpdated = 0
              this.$store.dispatch(BrandConfigurationShopifySettings.actions.setSelectedBrandConfigurationShopifySettings, null)
              console.log('Brand Branch Offices not visible!!!')
            }
          }
        },
        loadItems () {
          this.$store.dispatch(BrandConfigurationShopifySettings.actions.loadBrandConfigurationShopifySettings)
        },
        editItem (index) {
          this.formDisabled = false
          this.$store.dispatch(BrandConfigurationShopifySettings.actions.setSelectedBrandConfigurationShopifySettings, this.items[index])
        },
        showDeleteDialog (index) {
          this.removeDialog = true
          this.itemToDelete = index
        },
        removeItem (index) {
          this.removeDialog = false
          this.$store.dispatch(BrandConfigurationShopifySettings.actions.removeItem, this.itemToDelete)
          this.formUpdated = 0
          this.formDisabled = true
        },
        addNewItem () {
          let item = {
            id: null,
            name: 'New Brand Shopify Setting',
            base_url: null,
            access_token: null,
            api_version: null
          }
          this.$store.dispatch(BrandConfigurationShopifySettings.actions.setSelectedBrandConfigurationShopifySettings, item)
          this.$store.dispatch(BrandConfigurationShopifySettings.actions.addNewItem, item)
        },
        saveAndGoToNextTab (index) {
          if (!this.$refs.form.validate()) {
            return
          }
          this.$store.dispatch(BrandConfigurationShopifySettings.actions.saveBrandConfigurationShopifySettings, this.items)
          this.formUpdated = 0
          this.confirmPW = null
        }

      },
      computed: {
        selectedItem () {
          return this.$store.getters[BrandConfigurationShopifySettings.getters.getSelectedBrandConfigurationShopifySettings]
        },
        selectedBrandConfiguration () {
          return this.$store.getters[BrandConfiguration.getters.getSelectedBrandConfiguration]
        },
        items () {
          return this.$store.getters[BrandConfigurationShopifySettings.getters.brandConfigurationShopifySettings]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('formEdited: ' + this.formUpdated)
          return this.formUpdated < 2
        }
      },
      watch: {
        items: {
          handler (val) {
            console.log('form data changed: ' + JSON.stringify(val))
            this.formUpdated++
          },
          deep: true
        }

      }
    }
</script>

<style scoped>
    .branchOfficesList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-loading {
        margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Settings/BrandConfiguration/BrandConfigurationShopifySettings.vue